module.exports = __webpack_public_path__ + "media/images/writer/home/home-01@3x-0157f291e27438ab42e9b38f6b8f3c93.png";